import { camelize } from '@ember/string';
import { Card } from '@square/dashboard-protos/models/squareup/connect/v2/resources/card';
import { CardTender } from '@square/dashboard-protos/models/squareup/bills/tender';
import { captureException, withScope } from '@sentry/ember';
// eslint-disable-next-line complexity
export function getDisplayName(cardBrand, intl, features) {
  if (cardBrand && typeof cardBrand !== 'string') {
    withScope(scope => {
      scope.setContext('details', {
        cardBrand,
        cardBrandTypeOf: typeof cardBrand
      });
      captureException(new Error('cardBrand.getDisplayName called with non-string argument'));
    });
    return null;
  }
  switch (cardBrand && camelize(cardBrand.toLowerCase())) {
    case 'afterpay':
      if (features?.isEnabled('dashboard/show_clearpay_branding')) {
        return intl.t('common.cardBrands.clearpay');
      }
      return intl.t('common.cardBrands.afterpay');
    case 'alipay':
      return intl.t('common.cardBrands.alipay');
    case 'amex':
    case 'americanExpress':
      return intl.t('common.cardBrands.americanExpress');
    case 'cashApp':
      return intl.t('common.cardBrands.cashApp');
    case 'discover':
      return intl.t('common.cardBrands.discover');
    case 'discoverDiners':
      return intl.t('common.cardBrands.discoverDiners');
    case 'ebt':
      return intl.t('common.cardBrands.ebt');
    case 'eftpos':
      return intl.t('common.cardBrands.eftpos');
    case 'felica':
      return intl.t('common.cardBrands.felica');
    case 'interac':
      return intl.t('common.cardBrands.interac');
    case 'jcb':
      return intl.t('common.cardBrands.jcb');
    case 'mastercard':
    case 'masterCard':
      return intl.t('common.cardBrands.masterCard');
    case 'paypay':
      return intl.t('common.cardBrands.paypay');
    case 'squareAccountBalance':
      return intl.t('common.cardBrands.squareAccountBalance');
    case 'squareGiftCard':
    case 'squareGiftCardV2':
      return intl.t('common.cardBrands.squareGiftCardV2');
    case 'chinaUnionpay':
    case 'unionPay':
      return intl.t('common.cardBrands.unionPay');
    case 'unknown':
      return intl.t('common.cardBrands.unknown');
    case 'visa':
      return intl.t('common.cardBrands.visa');
    case 'squareCapitalCard':
      return intl.t('common.cardBrands.squareCapitalCard');
    default:
      return null;
  }
}
export function getDisplayNameFromConnect(cardBrand, intl) {
  switch (cardBrand) {
    case Card.Brand.OTHER_BRAND:
      return intl.t('common.cardBrands.unknown');
    case Card.Brand.VISA:
      return intl.t('common.cardBrands.visa');
    case Card.Brand.MASTERCARD:
      return intl.t('common.cardBrands.masterCard');
    case Card.Brand.DISCOVER:
      return intl.t('common.cardBrands.discover');
    case Card.Brand.DISCOVER_DINERS:
      return intl.t('common.cardBrands.discoverDiners');
    case Card.Brand.JCB:
      return intl.t('common.cardBrands.jcb');
    case Card.Brand.SQUARE_GIFT_CARD:
      return intl.t('common.cardBrands.squareGiftCardV2');
    case Card.Brand.CHINA_UNIONPAY:
      return intl.t('common.cardBrands.unionPay');
    case Card.Brand.AMERICAN_EXPRESS:
      return intl.t('common.cardBrands.americanExpress');
    case Card.Brand.SQUARE_CAPITAL_CARD:
      return intl.t('common.cardBrands.squareCapitalCard');
    case Card.Brand.INTERAC:
      return intl.t('common.cardBrands.interac');
    case Card.Brand.EBT:
      // TODO (rothlisberger) add a real translation
      return intl.t('common.cardBrands.unknown');
    case Card.Brand.EFTPOS:
      // TODO (rothlisberger) add a real translation
      return intl.t('common.cardBrands.unknown');
    case Card.Brand.FELICA:
      return intl.t('common.cardBrands.felica');
    default:
      return null;
  }
}
export function getDisplayNameForSquareupTender(cardBrand, intl) {
  switch (cardBrand) {
    case CardTender.Card.Brand.UNKNOWN_BRAND:
      return intl.t('common.cardBrands.unknown');
    case CardTender.Card.Brand.VISA:
      return intl.t('common.cardBrands.visa');
    case CardTender.Card.Brand.MASTERCARD:
      return intl.t('common.cardBrands.masterCard');
    case CardTender.Card.Brand.AMERICAN_EXPRESS:
      return intl.t('common.cardBrands.americanExpress');
    case CardTender.Card.Brand.DISCOVER:
      return intl.t('common.cardBrands.discover');
    case CardTender.Card.Brand.DISCOVER_DINERS:
      return intl.t('common.cardBrands.discoverDiners');
    case CardTender.Card.Brand.JCB:
      return intl.t('common.cardBrands.jcb');
    case CardTender.Card.Brand.CHINA_UNIONPAY:
      return intl.t('common.cardBrands.unionPay');
    case CardTender.Card.Brand.SQUARE_GIFT_CARD_V2:
      return intl.t('common.cardBrands.squareGiftCardV2');
    case CardTender.Card.Brand.INTERAC:
      return intl.t('common.cardBrands.interac');
    case CardTender.Card.Brand.FELICA:
      return intl.t('common.cardBrands.felica');
    default:
      return null;
  }
}